export default "__VITE_ASSET__CBvumeTZ__"